<template>

    <Link :href="href"
        class="hover:underline font-nexa text-blue hover:text-opacity-90">

        <slot></slot>

    </Link>

</template>

<script>

import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    components: {
        Link,
    },

    props: {
        href: String,
        active: String
    }

});

</script>
